import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export class Loading {
  status: string;
  isLoader: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private isLoading = new Subject<Loading>();

  constructor() {}

  public UpdateLoader(loader: Loading) {
    this.isLoading.next(loader);
  }

  public isLoader(): Observable<Loading> {
    return this.isLoading;
  }
}
